angular.module("newUploadIcon.components", []).component("newUploadIcon", {
  templateUrl: "ng/components/newUploadIcon/newUploadIcon.view.html",
  bindings: {
    dimension: '<',
    startUpload: "<",
    endUpload: "<",
    idComponent: "@",
    isDownload: '<'
  },
  controller: NewUploadIconController,
  controllerAs: "newUploadIconCtrl",
});

function NewUploadIconController(
  $timeout
) {
  var self = this;

  self.$onInit = function () {
    self.dimension = self.dimension || 3;
  };

  self.$onChanges = function (changed) {
    if (changed.startUpload && changed.startUpload.currentValue) {
      console.log("start upload metod");
      startUpload();
    }

    if (changed.endUpload && changed.endUpload.currentValue) {
      console.log("start upload metod");
      endUpload();
    }
  };

  var startUpload = function () {
    jQuery('#pil-' + self.idComponent).addClass('removePil');
    jQuery('#pil-' + self.idComponent).addClass('hide-element');
    jQuery('#external-' + self.idComponent).addClass('utveckling');


  }

  var endUpload = function () {
    jQuery('#external-' + self.idComponent).removeClass('utveckling');
    jQuery('#bock-' + self.idComponent).removeClass('hide-element');
    jQuery('#bock-' + self.idComponent).addClass('bock');
    $timeout(function () {
      jQuery('#bock-' + self.idComponent).addClass('removeBock');
      jQuery('#pil-' + self.idComponent).removeClass('hide-element');
      jQuery('#pil-' + self.idComponent).addClass('addPil');
      jQuery('#bock-' + self.idComponent).addClass('hide-element');
      $timeout(function () {
        jQuery('#pil-' + self.idComponent).removeClass('removePil addPil');
        jQuery('#bock-' + self.idComponent).removeClass('bock removeBock');
      }, 1200);
    }, 2000)
  }
}